import axios from 'axios'
import 'url-search-params-polyfill'

import _ from 'lodash'
import apiConfiguration from '../utilities/api/apiConfiguration'
import fetchLoyaltyRates from './fetchLoyaltyRates'
import {getClientIdByHotelCode, getEndpointByHotelCode} from "../utilities/property/getClientIdByHotelCode";

export const FETCH_HOTEL_DESC_INFO_BEGIN   = 'FETCH_HOTEL_DESC_INFO_BEGIN'
export const FETCH_HOTEL_DESC_INFO_SUCCESS = 'FETCH_HOTEL_DESC_INFO_SUCCESS'
export const FETCH_HOTEL_DESC_INFO_FAILURE = 'FETCH_HOTEL_DESC_INFO_FAILURE'

export const fetchHotelDescInfoBegin = () => ({
	type: FETCH_HOTEL_DESC_INFO_BEGIN,
})

export const fetchHotelDescInfoSuccess = hotelInfo => ({
	type: FETCH_HOTEL_DESC_INFO_SUCCESS,
	payload: hotelInfo
})

export const fetchHotelDescInfoError = error => ({
	type: FETCH_HOTEL_DESC_INFO_FAILURE,
	payload: { error }
})

// Handle Availability Fetch & Functionality
export default function fetchHotelDescriptiveInfo(userLoyaltyTier) {
	return (dispatch) => {
		// Import Query string & Parse URL
		const queryString = require('query-string')
		const urlQuery = queryString.parse(window.location.search)

    let currentClientId = getClientIdByHotelCode(urlQuery.hotelCode);
		let currentEndpointUrl = getEndpointByHotelCode(urlQuery.hotelCode);

		// Set default lang
		let currentLanguage = 'en'
		let hotelProvider = 0

		// Use lang query param
		if (urlQuery.primaryLangId) {
			currentLanguage = urlQuery.primaryLangId
		}

		if (urlQuery.hotelProvider) {
			hotelProvider = urlQuery.hotelProvider
		}

		let hotelInfoUrlParams = {
			hotelCode: urlQuery.hotelCode,
			primaryLangId: currentLanguage,
			hotelProvider: hotelProvider,
			clientId: currentClientId,
		}

		// Fetch query string method
		const fetchHotelDescInfoQuery = new URLSearchParams()

		// Loop params for blank values
		for (let key in hotelInfoUrlParams) {
			if (typeof hotelInfoUrlParams[key] === "undefined") continue
			fetchHotelDescInfoQuery.append(key, hotelInfoUrlParams[key])
		}

		// Base API path
		let apiBase = currentEndpointUrl + '/api/hotel/info?'

		// Combine API URL & formatted enhancementUrlParams
		const fetchHotelDescInfoResult = apiBase + fetchHotelDescInfoQuery.toString()

		dispatch(fetchHotelDescInfoBegin())
		return axios.get(fetchHotelDescInfoResult, apiConfiguration())
			.then((response) => {
				const hotelInfo = _.get(response, "data['hydra:member'][0]", {})
				const loyaltyTiers =  _.get(hotelInfo, 'viewExtensions.loyaltyTiers', [])
				const currentLoyaltyRates = loyaltyTiers.find(tier => {
					return tier.tier === userLoyaltyTier
				})
				const loyaltyRateCodes = _.get(currentLoyaltyRates, 'ratePlans', [])

				if (hotelInfo) {
					dispatch(fetchHotelDescInfoSuccess(hotelInfo))
				}

				if (!_.isEmpty(loyaltyRateCodes)) {
					loyaltyRateCodes.forEach(rate => {
						dispatch(fetchLoyaltyRates(rate))
					})
				}
			})
			.catch(error => {
				dispatch(fetchHotelDescInfoError(error))
			})
	}
}


// WEBPACK FOOTER //
// ./src/actions/fetchHotelDescriptiveInfo.js